import { request } from "utils/proxy";

export const HUMAN_ETHICS_STUDIES_API = "/sp/api/human-ethics/studies";

const searchFacets = [
	{
		key: "title",
		text: "Title",
		facetType: "text"
	},
	{
		key: "studyNumber",
		text: "Study Number",
		facetType: "text"
	},
	{
		key: "principleInvestigator",
		text: "PI",
		facetType: "text"
	}
];

const mapResults = results => results.map(result => {
	const { studyNumber, title = "Title N/A", principleInvestigator = "PI N/A" } = result;

	return {
		key: studyNumber,
		text: `${studyNumber} - ${title} - ${principleInvestigator}`
	};
});

const fetchData = async (linkedStudyIds) => {
	if (!linkedStudyIds.length) return [];
	const query = linkedStudyIds.map(id => `studyIds=${encodeURIComponent(id)}`).join("&");
	return request(`${HUMAN_ETHICS_STUDIES_API}?${query}`, { notifyUponError: false });
};

const Helper = {
	apiKey: "studyNumber",
	searchFacets,
	mapResults,
	fetchData
};

export default Helper;